import { Outlet, useNavigate, useParams } from 'react-router-dom'
import { ChevronDown } from 'lucide-react'
import { useStatsData } from '../hooks/useStatsData'

const Layout = ({ children }) => {
  const navigate = useNavigate()
  const { playerId } = useParams()
  const { data: allPlayers, loading } = useStatsData()

  const handlePlayerChange = (newPlayerId) => {
    navigate(`/player/${newPlayerId}`)
  }

  const currentPlayer = allPlayers?.find(p => p.player_id.toString() === playerId)

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 cursor-pointer" onClick={() => navigate('/')}>
                Stats - TTCoach
              </h1>
              {currentPlayer?.updated_at && (
                <p className="text-xs text-gray-400 mt-1">
                  Updated: {new Date(currentPlayer.updated_at).toLocaleDateString('de-DE', { 
                    year: 'numeric', 
                    month: '2-digit', 
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </p>
              )}
            </div>

            {/* Player Selector - right aligned */}
            {playerId && allPlayers && (
              <div className="relative">
                <select 
                  value={playerId} 
                  onChange={(e) => handlePlayerChange(e.target.value)}
                  className="appearance-none bg-white border border-gray-300 rounded-md px-4 py-2 pr-10 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {allPlayers.map(player => (
                    <option key={player.player_id} value={player.player_id}>
                      {player.player_name}
                    </option>
                  ))}
                </select>
                <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
              </div>
            )}
          </div>
        </div>
      </header>
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children || <Outlet />}
      </main>
    </div>
  )
}

export default Layout